export default "__VITE_ASSET__d0431a3f__"